"use client";
import {  LoadingLottie } from "../loading";
import { UiSvgsPropsType } from "../svgs";



export function LottieLoading(props: Omit<UiSvgsPropsType, "name">) {

	return <LoadingLottie {...props} />
}